import { trigger, transition, style, animate } from '@angular/animations';

export const Fade = [
  trigger('fade', [

    transition(':enter', [
      style({ opacity: 0.3 , transform: 'scale(0.3)'}),
      animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1)'})),
    ]),
    transition(':leave', [
      animate('200ms ease-in', style({ opacity: 0 , transform: 'scale(0.1)'}))
    ])
  ])
];
